import { useEffect, useState } from "react";

import EditorArticle from "../../Data/EditorArticle.json"
import LastestArticle from "../../Data/LatestArticle.json"
import PopularArticle from "../../Data/PopularArticle.json"
import Newsletters from "../../Data/Newsletters.json";

import BlogItemCpn from "../../Component/Blog/BlogItemCpn";

import Pagination from '../../Component/Pagination/Pagination';

import { useParams } from 'react-router';



function BlogPage(){

     let sortTemp = 'Mới nhất';
     let arrTemp  = LastestArticle || [];

      const {filter = ""} = useParams() || {};
       switch(filter){
          case "popular":
         
            sortTemp = "Phổ biến";
            arrTemp = PopularArticle;
          break;

          case "editor":
            sortTemp = "Lựa chọn BTV";
            arrTemp = EditorArticle;
        break;

        default :
            sortTemp="Mới nhất";
            arrTemp = LastestArticle;
       }

    const [sorted,setSorted] = useState(sortTemp);
    const [arrData,setArrData] = useState(arrTemp);

     //phần phân trang
    //page hiển thị hiện tại
    const [currentPage, setCurrentPage] = useState(1);
    //số lượng phần tử trên 1 page
    const [pageSize,setPageSize] = useState(9);
    //kích thước mảng để phân trang
    // const [totalCount,setTotalCount] = useState(0);

        //firstPapgeIndex là vị trí bắt đầu của mảng cần hiển thị theo currentPage và pasiZe
    //ví dụ mảng có 150 phần tử currentPage là 1 và pasize là 50 thì firstPageIndex là 0 còn lastPageIndex là 50
    //currentPage là 2 và pasize là 50 thì firstPageIndex là 50 còn lastPageIndex là 100
    const [firstPapgeIndex,setFirstPageIndex] = useState(0);
    const [lastPageIndex,setLastPageIndex] = useState(9);

    const currentTableData = (page) =>{
        const firstIndex = (page - 1) * pageSize;
        const lastIndex = firstIndex + pageSize;
        
        setFirstPageIndex(firstIndex);
        setLastPageIndex(lastIndex);
        setCurrentPage(page);
      }

      const onclickSorted = (val)=>{
        setSorted(val);

        switch(val) {
            case "Mới nhất":
              setArrData(LastestArticle);
            break;
            case "Phổ biến":
                setArrData(PopularArticle);
              break;
             case "Lựa chọn BTV":
                setArrData(EditorArticle)
                break;
            default:
             
          }
    }  



    useEffect(()=>{
        window.addEventListener('click', function(e){
            if (document.getElementById('sortby1') !== null &&!document.getElementById('sortby1').contains(e.target))
            {
                if(document.getElementById("divSort") != null)
                    document.getElementById("divSort").setAttribute("style","display:none");
            }

            if (document.getElementById('sortby2') !== null &&!document.getElementById('sortby2').contains(e.target))
            {
                if(document.getElementById("divSort2") != null)
                    document.getElementById("divSort2").setAttribute("style","display:none");
            }
        },false)   
    },[])
   

    const handleSort = ()=>{
        var display = window.getComputedStyle(document.getElementById("divSort")).getPropertyValue("display");
        if(display === "none")
        {
            document.getElementById("divSort").setAttribute("style","display:block");
        }
        else
        {
            document.getElementById("divSort").setAttribute("style","display:none");
        }
    }

    const handleSort2 = ()=>{
        var display = window.getComputedStyle(document.getElementById("divSort2")).getPropertyValue("display");
        if(display === "none")
        {
            document.getElementById("divSort2").setAttribute("style","display:block");
        }
        else
        {
            document.getElementById("divSort2").setAttribute("style","display:none");
        }
    }


 


    return (
        <>
            <div className="Layout_childrenDiv__uf2y3">
    <div className="Layout_mainCookieDiv__7nVqL">
        <div className="Layout_componentCookieDiv__jDU_3" />
    </div>
    <div>
        <div className="BlogsCategories_mainDiv__Q4gGl">
        <div className="BlogsCategories_blogsHeaderMobileDiv__uUrmX">
            <div className="BlogsCategories_blogsHeader__7UWnj">
            <h1>Blog</h1>
            </div>
            <div>
            <div className="SearchBlogs_searchDiv__MryqR">
                <div className="SearchBlogs_searchBar__JxR_N">
                <div className="SearchBlogs_searchIconDiv__32rRI">
                    <svg
                    stroke="currentColor"
                    fill="none"
                    strokeWidth={2}
                    viewBox="0 0 24 24"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    className="SearchBlogs_searchIcon__2sZtd"
                    height="1em"
                    width="1em"
                    xmlns="http://www.w3.org/2000/svg"
                    >
                    <circle cx={11} cy={11} r={8} />
                    <line x1={21} y1={21} x2="16.65" y2="16.65" />
                    </svg>
                </div>
                <div className="SearchBlogs_searchInputDiv__4UKj8">
                    <input type="text" placeholder="Tìm kiếm" defaultValue="" />
                </div>{" "}
                {/* <div className="SearchBlogs_blogCategoriesDropdown__qJzfj">
                    <div className="SearchBlogs_lineIconDiv__7e7hz"> | </div>
                    <svg
                    stroke="currentColor"
                    fill="currentColor"
                    strokeWidth={0}
                    viewBox="0 0 24 24"
                    className="SearchBlogs_filterIcon__o9rmx"
                    height="1em"
                    width="1em"
                    xmlns="http://www.w3.org/2000/svg"
                    >
                    <path fill="none" d="M0 0h24v24H0z" />
                    <path d="M10 18h4v-2h-4v2zM3 6v2h18V6H3zm3 7h12v-2H6v2z" />
                    </svg>
                </div> */}
                </div>
                <div className="SearchBlogs_hideBlogCategories__31NRk">
                <div>
                    <div className="SearchBlogs_hoverCategories__4ROZd">
                    <div>
                        <div className="SearchBlogs_categoryNameActive___guTQ">
                        All Categories
                        </div>
                    </div>
                    </div>
                    <div className="SearchBlogs_hoverCategories__4ROZd">
                    <div>
                        <div className="SearchBlogs_categoryName__P4L_h">
                        Adoption
                        </div>
                    </div>
                    </div>
                    <div className="SearchBlogs_hoverCategories__4ROZd">
                    <div>
                        <div className="SearchBlogs_categoryName__P4L_h">
                        Analysis
                        </div>
                    </div>
                    </div>
                    <div className="SearchBlogs_hoverCategories__4ROZd">
                    <div>
                        <div className="SearchBlogs_categoryName__P4L_h">
                        Blockchain
                        </div>
                    </div>
                    </div>
                    <div className="SearchBlogs_hoverCategories__4ROZd">
                    <div>
                        <div className="SearchBlogs_categoryName__P4L_h">Defi</div>
                    </div>
                    </div>
                    <div className="SearchBlogs_hoverCategories__4ROZd">
                    <div>
                        <div className="SearchBlogs_categoryName__P4L_h">
                        Education
                        </div>
                    </div>
                    </div>
                    <div className="SearchBlogs_hoverCategories__4ROZd">
                    <div>
                        <div className="SearchBlogs_categoryName__P4L_h">
                        Guest Post
                        </div>
                    </div>
                    </div>
                    <div className="SearchBlogs_hoverCategories__4ROZd">
                    <div>
                        <div className="SearchBlogs_categoryName__P4L_h">
                        Guides
                        </div>
                    </div>
                    </div>
                    <div className="SearchBlogs_hoverCategories__4ROZd">
                    <div>
                        <div className="SearchBlogs_categoryName__P4L_h">ICO</div>
                    </div>
                    </div>
                    <div className="SearchBlogs_hoverCategories__4ROZd">
                    <div>
                        <div className="SearchBlogs_categoryName__P4L_h">
                        Interview
                        </div>
                    </div>
                    </div>
                    <div className="SearchBlogs_hoverCategories__4ROZd">
                    <div>
                        <div className="SearchBlogs_categoryName__P4L_h">
                        Mining
                        </div>
                    </div>
                    </div>
                    <div className="SearchBlogs_hoverCategories__4ROZd">
                    <div>
                        <div className="SearchBlogs_categoryName__P4L_h">News</div>
                    </div>
                    </div>
                    <div className="SearchBlogs_hoverCategories__4ROZd">
                    <div>
                        <div className="SearchBlogs_categoryName__P4L_h">
                        Press Release
                        </div>
                    </div>
                    </div>
                    <div className="SearchBlogs_hoverCategories__4ROZd">
                    <div>
                        <div className="SearchBlogs_categoryName__P4L_h">
                        Review
                        </div>
                    </div>
                    </div>
                    <div className="SearchBlogs_hoverCategories__4ROZd">
                    <div>
                        <div className="SearchBlogs_categoryName__P4L_h">
                        Services
                        </div>
                    </div>
                    </div>
                    <div className="SearchBlogs_hoverCategories__4ROZd">
                    <div>
                        <div className="SearchBlogs_categoryName__P4L_h">
                        Smart Contracts
                        </div>
                    </div>
                    </div>
                    <div className="SearchBlogs_hoverCategories__4ROZd">
                    <div>
                        <div className="SearchBlogs_categoryName__P4L_h">
                        Technology
                        </div>
                    </div>
                    </div>
                    <div className="SearchBlogs_hoverCategories__4ROZd">
                    <div>
                        <div className="SearchBlogs_categoryName__P4L_h">
                        Trading
                        </div>
                    </div>
                    </div>
                    <div className="SearchBlogs_hoverCategories__4ROZd">
                    <div>
                        <div className="SearchBlogs_categoryName__P4L_h">
                        CB Consulting
                        </div>
                    </div>
                    </div>
                    <div className="SearchBlogs_hoverCategories__4ROZd">
                    <div>
                        <div className="SearchBlogs_categoryName__P4L_h">Event</div>
                    </div>
                    </div>
                </div>
                </div>
            </div>
            </div>
            <div className="BlogsCategories_sortByDiv__DFvs5">
            Sắp xếp:
                <div id="sortby2" className="BlogsCategories_dropdownDiv__z_os2" onClick={()=>{handleSort2()}}>
                    
                    <div>
                        <div className="BlogsCategories_dropdownBtn__OG9EH">
                            <span className="BlogsCategories_titleSpan__aC_fx">{sorted}</span>
                        </div>

                        <div id="divSort2" className="BlogsCategories_dropdownContent__vMxMQ" style={{display:"none"}}>
                            <div className="BlogsCategories_dropdownItemDiv__MBmL9" onClick={()=>{onclickSorted("Mới nhất")}}>
                                <div className="BlogsCategories_dropdownItem__bTurC">
                                <span>Mới nhất</span>
                                </div>
                            </div>
                            <div className="BlogsCategories_dropdownItemDiv__MBmL9" onClick={()=>{onclickSorted("Phổ biến")}}>
                                <div className="BlogsCategories_dropdownItem__bTurC">
                                <span>Phổ biến</span>
                                </div>
                            </div>
                            <div className="BlogsCategories_dropdownItemDiv__MBmL9" onClick={()=>{onclickSorted("Lựa chọn BTV")}}>
                                <div className="BlogsCategories_dropdownItem__bTurC">
                                <span>Lựa chọn BTV</span>
                                </div>
                            </div>
                        </div>

                       

                    </div>
                    
                    
                    <svg
                    stroke="currentColor"
                    fill="currentColor"
                    strokeWidth={0}
                    viewBox="0 0 24 24"
                    className="BlogsCategories_arrowIcon__ruIhN"
                    height="1em"
                    width="1em"
                    xmlns="http://www.w3.org/2000/svg"
                    >
                    <path fill="none" d="M0 0h24v24H0V0z" />
                    <path d="M7.41 8.59L12 13.17l4.59-4.58L18 10l-6 6-6-6 1.41-1.41z" />
                    </svg>
                </div>
            </div>
        </div>
        <div className="BlogsCategories_blogsPageDiv__1aiKM">
            {/* <div className="BlogsCategories_blogsCategoriesDiv__M8Kwp">
            <div className="BlogsCategories_blogCategoryHeader__z1aAK">
                Blog Categories
            </div>
            <div className="BlogsCategories_blogCategories__cuIiY">
                <div className="BlogsCategories_hoverCategories__CyH03">
                <div>
                    <div className="BlogsCategories_categoryName__PSrEy">
                    All Categories
                    </div>
                </div>
                </div>
                <div className="BlogsCategories_hoverCategories__CyH03">
                <div>
                    <div className="BlogsCategories_categoryName__PSrEy">
                    Adoption
                    </div>
                </div>
                </div>
                <div className="BlogsCategories_hoverCategories__CyH03">
                <div>
                    <div className="BlogsCategories_categoryName__PSrEy">
                    Analysis
                    </div>
                </div>
                </div>
                <div className="BlogsCategories_hoverCategories__CyH03">
                <div>
                    <div className="BlogsCategories_categoryName__PSrEy">
                    Blockchain
                    </div>
                </div>
                </div>
                <div className="BlogsCategories_hoverCategories__CyH03">
                <div>
                    <div className="BlogsCategories_categoryName__PSrEy">Defi</div>
                </div>
                </div>
                <div className="BlogsCategories_hoverCategories__CyH03">
                <div>
                    <div className="BlogsCategories_categoryName__PSrEy">
                    Education
                    </div>
                </div>
                </div>
                <div className="BlogsCategories_hoverCategories__CyH03">
                <div>
                    <div className="BlogsCategories_categoryName__PSrEy">
                    Guest Post
                    </div>
                </div>
                </div>
                <div className="BlogsCategories_hoverCategories__CyH03">
                <div>
                    <div className="BlogsCategories_categoryName__PSrEy">
                    Guides
                    </div>
                </div>
                </div>
                <div className="BlogsCategories_hoverCategories__CyH03">
                <div>
                    <div className="BlogsCategories_categoryName__PSrEy">ICO</div>
                </div>
                </div>
                <div className="BlogsCategories_hoverCategories__CyH03">
                <div>
                    <div className="BlogsCategories_categoryName__PSrEy">
                    Interview
                    </div>
                </div>
                </div>
                <div className="BlogsCategories_hoverCategories__CyH03">
                <div>
                    <div className="BlogsCategories_categoryName__PSrEy">
                    Mining
                    </div>
                </div>
                </div>
                <div className="BlogsCategories_hoverCategories__CyH03">
                <div>
                    <div className="BlogsCategories_categoryName__PSrEy">News</div>
                </div>
                </div>
                <div className="BlogsCategories_hoverCategories__CyH03">
                <div>
                    <div className="BlogsCategories_categoryName__PSrEy">
                    Press Release
                    </div>
                </div>
                </div>
                <div className="BlogsCategories_hoverCategories__CyH03">
                <div>
                    <div className="BlogsCategories_categoryName__PSrEy">
                    Review
                    </div>
                </div>
                </div>
                <div className="BlogsCategories_hoverCategories__CyH03">
                <div>
                    <div className="BlogsCategories_categoryName__PSrEy">
                    Services
                    </div>
                </div>
                </div>
                <div className="BlogsCategories_hoverCategories__CyH03">
                <div>
                    <div className="BlogsCategories_categoryName__PSrEy">
                    Smart Contracts
                    </div>
                </div>
                </div>
                <div className="BlogsCategories_hoverCategories__CyH03">
                <div>
                    <div className="BlogsCategories_categoryName__PSrEy">
                    Technology
                    </div>
                </div>
                </div>
                <div className="BlogsCategories_hoverCategories__CyH03">
                <div>
                    <div className="BlogsCategories_categoryName__PSrEy">
                    Trading
                    </div>
                </div>
                </div>
                <div className="BlogsCategories_hoverCategories__CyH03">
                <div>
                    <div className="BlogsCategories_categoryName__PSrEy">
                    CB Consulting
                    </div>
                </div>
                </div>
                <div className="BlogsCategories_hoverCategories__CyH03">
                <div>
                    <div className="BlogsCategories_categoryName__PSrEy">Event</div>
                </div>
                </div>
            </div>
            </div> */}
            <div className="BlogsCategories_blogsDiv__M5k50">
            <div className="BlogsCategories_blogsHeaderDiv__oUCRS">
                <div className="BlogsCategories_headerDiv___TIkZ">
                <div className="BlogsCategories_blogsHeader__7UWnj">
                    <h1>Blog</h1>
                </div>
                <div className="BlogsCategories_sortByDiv__DFvs5" >
                    Sắp xếp theo:
                    <div id="sortby1" className="BlogsCategories_dropdownDiv__z_os2"  onClick={()=>{handleSort()}}>
                        
                        <div>
                            <div className="BlogsCategories_dropdownBtn__OG9EH">
                            <span className="BlogsCategories_titleSpan__aC_fx">
                                {sorted}
                            </span>
                            </div>

                            <div id="divSort" className="BlogsCategories_dropdownContent__vMxMQ" style={{display:"none"}}>
                                <div className="BlogsCategories_dropdownItemDiv__MBmL9" onClick={()=>{onclickSorted("Mới nhất")}}>
                                    <div className="BlogsCategories_dropdownItem__bTurC">
                                    <span>Mới nhất</span>
                                    </div>
                                </div>
                                <div className="BlogsCategories_dropdownItemDiv__MBmL9" onClick={()=>{onclickSorted("Phổ biến")}}>
                                    <div className="BlogsCategories_dropdownItem__bTurC">
                                    <span>Phổ biến</span>
                                    </div>
                                </div>
                                <div className="BlogsCategories_dropdownItemDiv__MBmL9" onClick={()=>{onclickSorted("Lựa chọn BTV")}}>
                                    <div className="BlogsCategories_dropdownItem__bTurC">
                                    <span>Lựa chọn BTV</span>
                                    </div>
                                </div>
                            </div>


                        </div>
                        
                        <svg
                            stroke="currentColor"
                            fill="currentColor"
                            strokeWidth={0}
                            viewBox="0 0 24 24"
                            className="BlogsCategories_arrowIcon__ruIhN"
                            height="1em"
                            width="1em"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <path fill="none" d="M0 0h24v24H0V0z" />
                            <path d="M7.41 8.59L12 13.17l4.59-4.58L18 10l-6 6-6-6 1.41-1.41z" />
                        </svg>
                    </div>
                </div>
                </div>
                <div>
                <div className="SearchBlogs_searchDiv__MryqR">
                    <div className="SearchBlogs_searchBar__JxR_N">
                    <div className="SearchBlogs_searchIconDiv__32rRI">
                        <svg
                        stroke="currentColor"
                        fill="none"
                        strokeWidth={2}
                        viewBox="0 0 24 24"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        className="SearchBlogs_searchIcon__2sZtd"
                        height="1em"
                        width="1em"
                        xmlns="http://www.w3.org/2000/svg"
                        >
                        <circle cx={11} cy={11} r={8} />
                        <line x1={21} y1={21} x2="16.65" y2="16.65" />
                        </svg>
                    </div>
                    <div className="SearchBlogs_searchInputDiv__4UKj8">
                        <input type="text" placeholder="Tìm kiếm" defaultValue="" />
                    </div>{" "}
                    {/* <div className="SearchBlogs_blogCategoriesDropdown__qJzfj">
                        <div className="SearchBlogs_lineIconDiv__7e7hz"> | </div>
                        <svg
                        stroke="currentColor"
                        fill="currentColor"
                        strokeWidth={0}
                        viewBox="0 0 24 24"
                        className="SearchBlogs_filterIcon__o9rmx"
                        height="1em"
                        width="1em"
                        xmlns="http://www.w3.org/2000/svg"
                        >
                        <path fill="none" d="M0 0h24v24H0z" />
                        <path d="M10 18h4v-2h-4v2zM3 6v2h18V6H3zm3 7h12v-2H6v2z" />
                        </svg>
                    </div> */}
                    </div>
                    <div className="SearchBlogs_hideBlogCategories__31NRk">
                    <div>
                        <div className="SearchBlogs_hoverCategories__4ROZd">
                        <div>
                            <div className="SearchBlogs_categoryNameActive___guTQ">
                            All Categories
                            </div>
                        </div>
                        </div>
                        <div className="SearchBlogs_hoverCategories__4ROZd">
                        <div>
                            <div className="SearchBlogs_categoryName__P4L_h">
                            Adoption
                            </div>
                        </div>
                        </div>
                        <div className="SearchBlogs_hoverCategories__4ROZd">
                        <div>
                            <div className="SearchBlogs_categoryName__P4L_h">
                            Analysis
                            </div>
                        </div>
                        </div>
                        <div className="SearchBlogs_hoverCategories__4ROZd">
                        <div>
                            <div className="SearchBlogs_categoryName__P4L_h">
                            Blockchain
                            </div>
                        </div>
                        </div>
                        <div className="SearchBlogs_hoverCategories__4ROZd">
                        <div>
                            <div className="SearchBlogs_categoryName__P4L_h">
                            Defi
                            </div>
                        </div>
                        </div>
                        <div className="SearchBlogs_hoverCategories__4ROZd">
                        <div>
                            <div className="SearchBlogs_categoryName__P4L_h">
                            Education
                            </div>
                        </div>
                        </div>
                        <div className="SearchBlogs_hoverCategories__4ROZd">
                        <div>
                            <div className="SearchBlogs_categoryName__P4L_h">
                            Guest Post
                            </div>
                        </div>
                        </div>
                        <div className="SearchBlogs_hoverCategories__4ROZd">
                        <div>
                            <div className="SearchBlogs_categoryName__P4L_h">
                            Guides
                            </div>
                        </div>
                        </div>
                        <div className="SearchBlogs_hoverCategories__4ROZd">
                        <div>
                            <div className="SearchBlogs_categoryName__P4L_h">
                            ICO
                            </div>
                        </div>
                        </div>
                        <div className="SearchBlogs_hoverCategories__4ROZd">
                        <div>
                            <div className="SearchBlogs_categoryName__P4L_h">
                            Interview
                            </div>
                        </div>
                        </div>
                        <div className="SearchBlogs_hoverCategories__4ROZd">
                        <div>
                            <div className="SearchBlogs_categoryName__P4L_h">
                            Mining
                            </div>
                        </div>
                        </div>
                        <div className="SearchBlogs_hoverCategories__4ROZd">
                        <div>
                            <div className="SearchBlogs_categoryName__P4L_h">
                            News
                            </div>
                        </div>
                        </div>
                        <div className="SearchBlogs_hoverCategories__4ROZd">
                        <div>
                            <div className="SearchBlogs_categoryName__P4L_h">
                            Press Release
                            </div>
                        </div>
                        </div>
                        <div className="SearchBlogs_hoverCategories__4ROZd">
                        <div>
                            <div className="SearchBlogs_categoryName__P4L_h">
                            Review
                            </div>
                        </div>
                        </div>
                        <div className="SearchBlogs_hoverCategories__4ROZd">
                        <div>
                            <div className="SearchBlogs_categoryName__P4L_h">
                            Services
                            </div>
                        </div>
                        </div>
                        <div className="SearchBlogs_hoverCategories__4ROZd">
                        <div>
                            <div className="SearchBlogs_categoryName__P4L_h">
                            Smart Contracts
                            </div>
                        </div>
                        </div>
                        <div className="SearchBlogs_hoverCategories__4ROZd">
                        <div>
                            <div className="SearchBlogs_categoryName__P4L_h">
                            Technology
                            </div>
                        </div>
                        </div>
                        <div className="SearchBlogs_hoverCategories__4ROZd">
                        <div>
                            <div className="SearchBlogs_categoryName__P4L_h">
                            Trading
                            </div>
                        </div>
                        </div>
                        <div className="SearchBlogs_hoverCategories__4ROZd">
                        <div>
                            <div className="SearchBlogs_categoryName__P4L_h">
                            CB Consulting
                            </div>
                        </div>
                        </div>
                        <div className="SearchBlogs_hoverCategories__4ROZd">
                        <div>
                            <div className="SearchBlogs_categoryName__P4L_h">
                            Event
                            </div>
                        </div>
                        </div>
                    </div>
                    </div>
                </div>
                </div>
            </div>
            <div className="BlogsCategories_blogs__9ed2v">
                {arrData.slice(firstPapgeIndex,lastPageIndex).map(item=><BlogItemCpn data={item} />)}

            </div>
            <div className="BlogsCategories_pagination__mWyt_">
                <Pagination
                        currentPage={currentPage}
                        totalCount={arrData.length}
                        pageSize={9}
                        onPageChange={currentTableData}
                    />
            </div>


            </div>
        </div>
        </div>
    </div>
            </div>
        </>
    )
}

export default BlogPage;